<template>
  <q-form @submit="this.onSubmit" class="form">
    <div class="form__item">
      <CustomInput
        label="Название причины"
        type="text"
        :required="true"
        :value="formData.reason_name"
        @change_input="(value) => onChange('reason_name', value)"
        autofocus
        style="width: 100%;"
      />
    </div>
    <CustomModalFooter :btn-loading="this.loading" />
  </q-form>
</template>

<script>
import CustomInput from "@/components/form/CustomInput";
import CustomModalFooter from "@/components/modal/modals/modal-footer";

export default {
  name: "AddReason",
  components: { CustomInput, CustomModalFooter },
  props: ['data', 'closeModal'],
  data() {
    return {
      loading: false,
      formData: {
        reason_id: this.data?.reason?.reason_id || null,
        reason_name: this.data?.reason?.reason_name || '',
      }
    }
  },
  methods: {
    onChange(key, value) {
      this.formData[key] = value
    },
    async onSubmit() {
      if (!this.formData.reason_name || !this.formData.reason_name.trim()) {
        return;
      }
      this.loading = true
      const res = await this.data?.onSubmit(this.formData)
      this.loading = false
      if (res !== false) {
        this.closeModal?.()
      }
    },
  }
}
</script>

<style scoped lang="scss">
.form {
  display: flex;
  flex-direction: column;
  width: 400px;
  gap: 15px;

  &__item {
    width: 100%;
    display: flex;
    gap: 16px;

    :deep(.custom-input) {
      width: 100%;
      max-width: 100%;
    }
  }

  @media (max-width: 460px) {
    width: 100%;
  }
}
</style>

